export default __webpack_public_path__ + "static/media/cardReward2.b66a7780.png";